/* tslint:disable */
import { NgModule, ModuleWithProviders } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationInterface } from './api-configuration';

import { AccountServiceService } from './services/account-service.service';
import { BillingServiceService } from './services/billing-service.service';
import { ContactServiceService } from './services/contact-service.service';
import { FlavourServiceService } from './services/flavour-service.service';
import { ImageServiceService } from './services/image-service.service';
import { InstanceServiceService } from './services/instance-service.service';
import { NetworkServiceService } from './services/network-service.service';
import { NodeServiceService } from './services/node-service.service';
import { OauthServiceService } from './services/oauth-service.service';
import { PolicyServiceService } from './services/policy-service.service';
import { ProjectServiceService } from './services/project-service.service';
import { QueueServiceService } from './services/queue-service.service';
import { SshkeyServiceService } from './services/sshkey-service.service';
import { VolumeServiceService } from './services/volume-service.service';
import { ZoneServiceService } from './services/zone-service.service';

/**
 * Provider for all Api services, plus ApiConfiguration
 */
@NgModule({
  imports: [
    HttpClientModule
  ],
  exports: [
    HttpClientModule
  ],
  declarations: [],
  providers: [
    ApiConfiguration,
    AccountServiceService,
    BillingServiceService,
    ContactServiceService,
    FlavourServiceService,
    ImageServiceService,
    InstanceServiceService,
    NetworkServiceService,
    NodeServiceService,
    OauthServiceService,
    PolicyServiceService,
    ProjectServiceService,
    QueueServiceService,
    SshkeyServiceService,
    VolumeServiceService,
    ZoneServiceService
  ],
})
export class ApiModule {
  static forRoot(customParams: ApiConfigurationInterface): ModuleWithProviders {
    return {
      ngModule: ApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: {rootUrl: customParams.rootUrl}
        }
      ]
    }
  }
}
